import { ImageProps } from 'src/components/image';
import { i18n } from 'src/i18n';

import altiboxLogoIcon from './altibox-logo-footer.svg';
import arrowLeft from './arrow-left.svg';
import bigTvIcon from './big-tv.svg';
import buildingIcon from './building.svg';
import cellTowerIcon from './cell-tower.svg';
import clockIcon from './clock.svg';
import errorIcon from './error.svg';
import gamingIcon from './gaming.svg';
import houseIcon from './house.svg';
import monkeyIcon from './monkey.svg';
import owlIcon from './owl.svg';
import personIcon from './person.svg';
import phoneIcon from './phone.svg';
import q22 from './q22.svg';
import tvIcon from './tv.svg';
import warningIcon from './warning.svg';
import wifiIcon from './wifi.svg';

export const personImageProps: ImageProps = {
  src: personIcon,
  alt: i18n.image.person,
};

export const buildingImageProps: ImageProps = {
  src: buildingIcon,
  alt: i18n.image.building,
};

export const gamingImageProps: ImageProps = {
  src: gamingIcon,
  alt: i18n.image.gaming,
};

export const phoneImageProps: ImageProps = {
  src: phoneIcon,
  alt: i18n.image.phone,
};

export const tvImageProps: ImageProps = {
  src: tvIcon,
  alt: i18n.image.tv,
};

export const blackWifiImageProps: ImageProps = {
  src: wifiIcon,
  alt: i18n.image.wifi,
};

export const houseImageProps: ImageProps = {
  src: houseIcon,
  alt: i18n.image.housing,
};

export const warningImageProps: ImageProps = {
  src: warningIcon,
  alt: i18n.image.warning,
};

export const q22ImageProps: ImageProps = {
  src: q22,
  alt: i18n.image.q22,
};

export const owlImageProps: ImageProps = {
  src: owlIcon,
  alt: i18n.image.owl,
};

export const monkeyImageProps: ImageProps = {
  src: monkeyIcon,
  alt: i18n.image.monkey,
};

export const bigTvImageProps: ImageProps = {
  src: bigTvIcon,
  alt: i18n.image.bigTv,
};

export const arrowLeftImageProps: ImageProps = {
  src: arrowLeft,
  alt: i18n.image.arrowLeft,
};

export const errorImageProps: ImageProps = {
  src: errorIcon,
  alt: i18n.image.error,
};

export const altiboxLogoImageProps: ImageProps = {
  src: altiboxLogoIcon,
  alt: i18n.image.altiboxLogo,
};

export const cellTowerImageProps: ImageProps = {
  src: cellTowerIcon,
  alt: i18n.image.fixedWirelessAccess,
};

export const clockImageProps: ImageProps = {
  src: clockIcon,
  alt: i18n.image.clock,
};
